const apiClient = {
    baseURL: 'https://api.spotify.com/v1/',
};

export default apiClient;
